import { CarouselItemViewModel } from '@/types/cml-api';
import TileItem from './tile-item';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps, DataLayerProps {
  items?: CarouselItemViewModel[];
}
export default function TilesType({
  items,
  isLazy,
  sortKey,
  componentId
}: Props) {
  const carouselItems = items?.map((tile, index) => <TileItem key={tile.id || tile.link} isLazy={isLazy} {...tile} sortKey={sortKey} componentId={componentId} index={index} />);
  return <div className='grid grid-cols-2 gap-6' data-sentry-component="TilesType" data-sentry-source-file="tiles-type.tsx">{carouselItems}</div>;
}